import React from 'react';
import { Button } from '@/components/ui/button';
import { FileText, Plus } from 'lucide-react';

export function ParticipantChartEmptyState({ canCreate, onCreate }) {
  return (
    <div
      className="flex flex-col items-center justify-center text-center py-12 px-4 border-2 border-dashed rounded-lg bg-muted/30"
      data-testid="charts-empty-state"
    >
      <div className="w-14 h-14 rounded-full bg-background border flex items-center justify-center mb-3">
        <FileText className="w-7 h-7 text-muted-foreground/70" />
      </div>
      <h3 className="font-semibold text-base">No charts yet</h3>
      <p className="text-sm text-muted-foreground mt-1 max-w-md">
        No charts have been created for this participant yet. Charts help structured clinical monitoring
        — bowel, fluid, sleep, behaviour and more as they are released.
      </p>
      {canCreate && (
        <Button
          onClick={onCreate}
          size="sm"
          className="mt-4"
          data-testid="charts-empty-create-btn"
        >
          <Plus className="w-4 h-4 mr-1" />Create first chart
        </Button>
      )}
    </div>
  );
}
